// Patch for a Shopify-hosted bug in option_selection.js (Shopify.Product.prototype.update),
// which uses an undeclared loop variable ("property") and throws
// "ReferenceError: property is not defined" under strict mode. That error was aborting the
// theme's DOMContentLoaded init chain before it could reveal the buy box (.product_form.is-visible).
// This listener is registered before app.js's own DOMContentLoaded listener (this script tag is
// placed earlier in theme.liquid), so it runs first and fixes the method in place before the
// theme calls into it.
document.addEventListener('DOMContentLoaded', function () {
  if (window.Shopify && window.Shopify.Product && window.Shopify.Product.prototype) {
    window.Shopify.Product.prototype.update = function (json) {
      for (var property in json) {
        if (Object.prototype.hasOwnProperty.call(json, property)) {
          this[property] = json[property];
        }
      }
    };
  }

  // The theme's vendors.js bundles several jQuery plugins (Flickity, Fancybox, Waypoints), but
  // on this storefront their jQuery bridges ($.fn.flickity / $.fn.fancybox / $.fn.waypoint)
  // intermittently fail to register before app.js runs (looks like a load-order race inside
  // vendors.js). Whichever one is missing throws "$(...).X is not a function" partway through
  // app.js's single DOMContentLoaded handler, which aborts everything after it in that handler -
  // including the very end of it, which is what reveals the buy box and product gallery. This
  // restores each bridge defensively so none of them can be the thing that breaks the reveal.
  if (window.jQuery && window.Flickity && !window.jQuery.fn.flickity) {
    window.jQuery.fn.flickity = function (options) {
      return this.each(function () {
        var $this = window.jQuery(this);
        var instance = $this.data('flickity');
        if (instance) {
          if (options) instance.option(options);
          return;
        }
        instance = new window.Flickity(this, options);
        $this.data('flickity', instance);
      });
    };
  }

  if (window.jQuery && window.Waypoint && !window.jQuery.fn.waypoint) {
    window.jQuery.fn.waypoint = function (callback, options) {
      options = options || {};
      return this.each(function () {
        var el = this;
        var config = {};
        for (var k in options) {
          if (Object.prototype.hasOwnProperty.call(options, k)) config[k] = options[k];
        }
        config.element = el;
        config.handler = function (direction) {
          callback.call({ element: el }, direction);
        };
        new window.Waypoint(config);
      });
    };
  }

  if (window.jQuery && !window.jQuery.fn.fancybox) {
    // No usable global Fancybox instance was found on this page to bridge to a real
    // implementation. This is used here only for a couple of secondary lightbox call sites
    // (custom "lightbox" links, legacy backwards-compatibility hooks) - not for the buy box or
    // gallery - so a harmless no-op is far safer than guessing at a reimplementation, and it
    // stops it from being able to break anything else on the page.
    window.jQuery.fn.fancybox = function () {
      return this;
    };
  }

  // Belt-and-suspenders: whatever the underlying vendor-script issue turns out to be next time,
  // make sure the buy box gets revealed regardless. This runs on "load" (after DOMContentLoaded
  // and after app.js's handler has run or failed) and force-reveals the buy box if it's still
  // hidden, using the theme's own reveal function first and falling back to the CSS class
  // directly if that itself throws for some new reason.
  window.addEventListener('load', function () {
    var form = document.querySelector('.product_section .product_form');
    if (!form || form.classList.contains('is-visible')) return;
    try {
      if (window.productPage && typeof window.productPage.productSwatches === 'function') {
        window.productPage.productSwatches();
      }
    } catch (e) {
      // fall through to the direct class fallback below
    }
    if (!form.classList.contains('is-visible')) {
      form.classList.add('is-visible');
    }
  });
});